"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.roundDown = roundDown;
exports.roundUp = roundUp;

var _bignumber = _interopRequireDefault(require("bignumber.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Module dependencies.
 */

/**
 * Export `roundDown`.
 */
function roundDown(value, decimalPlaces) {
  return new _bignumber["default"](value).toFixed(decimalPlaces !== null && decimalPlaces !== void 0 ? decimalPlaces : 2, _bignumber["default"].ROUND_DOWN);
}
/**
 * Export `roundUp`.
 */


function roundUp(value, decimalPlaces) {
  return new _bignumber["default"](value).toFixed(decimalPlaces !== null && decimalPlaces !== void 0 ? decimalPlaces : 2, _bignumber["default"].ROUND_UP);
}